
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { Loading } from 'vant';
import qs from 'qs';
Vue.use(Popup).use(Dialog).use(Toast).use(Button).use(Loading);
@Component
export default class VoteButton extends Vue {
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop({ default: false }) voteWeChat!: boolean;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({ default: -1 }) voteIndex!: number;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  pointOut = false;
  unionId!: string | null;
  loading: boolean = false;
  throttleTimer: any = null;
  voteEnable = true;

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async onVote() {
    this.$emit('show');
    if (!window.udid) {
      this.openApp();
    }
  }

  openApp() {
    if (isWeiXin()) {
      Dialog.confirm({
        message: '可能离开微信\n打开第三方应用上游新闻',
        confirmButtonText: '继续',
        confirmButtonColor: '#e70021',
      })
        .then(() => {
          this.navToAppLoad();
        })
        .catch(() => {});
    } else {
      this.navToAppLoad();
    }
  }

  navToAppLoad() {
    //是否为ios
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    //是否为android
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;

    let obj = {
      dt: 7,
      url: document.location.href,
    };
    if (isiOS) {
      window.location.href = `https://jump.cqcb.com/shangyou_news/jump/jump.html?data=${encodeURIComponent(
        JSON.stringify(obj),
      )}`;
    } else if (isAndroid) {
      const jsonStr = JSON.stringify(obj);
      const schema = 'shangyounews://' + encodeURIComponent(jsonStr);
      window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews&android_schema=${schema}`;
    } else {
      window.location.href =
        'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
    }
  }
}
